import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { State } from 'store/types';
import { DispatchProps, StateProps } from './types';
import { operators as searchFormOperators } from 'store/search/form';
import FocusFeedForm from './SearchDateRange';
import profileSelector from 'store/app/profile/selectors';

const mapStateToProps = (state: State): StateProps => ({
	user: profileSelector.getUserInstance(state),
	beginDate: state.search.form.begin_date,
	endDate: state.search.form.end_date
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	onSetBeginDate: beginDate => dispatch(searchFormOperators.setBeginDate({ date: beginDate })),
	onSetEndDate: endDate => dispatch(searchFormOperators.setEndDate({ date: endDate }))
});

export default connect(mapStateToProps, mapDispatchToProps)(FocusFeedForm);
